"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookNewAppointmentFlowFooter = exports.BookNewAppointmentFlowBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("../../../store/store");
const bookingSlice_1 = require("../../../store/slices/bookingSlice");
const StepContainer_1 = __importDefault(require("./StepContainer"));
const TapChoices_1 = __importDefault(require("./TapChoices"));
const useHandleBooking_1 = __importDefault(require("../../../hooks/useHandleBooking"));
const BookNewAppointmentFlowBody = () => {
    const { currentStepIndex } = (0, store_1.useAppSelector)((state) => state.booking);
    const userCanMakeAppointment = (0, store_1.useAppSelector)((state) => (0, bookingSlice_1.canUserMakeAppointment)(state));
    const { selectedAppointment, isModalOpen: isOpen } = (0, useHandleBooking_1.default)();
    const [localAppointment, setLocalAppointment] = (0, react_1.useState)(selectedAppointment !== null && selectedAppointment !== void 0 ? selectedAppointment : undefined);
    (0, react_1.useEffect)(() => {
        if (!isOpen) {
            setLocalAppointment(undefined);
        }
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        setLocalAppointment(selectedAppointment !== null && selectedAppointment !== void 0 ? selectedAppointment : undefined);
    }, [selectedAppointment]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(userCanMakeAppointment === null || userCanMakeAppointment === void 0 ? void 0 : userCanMakeAppointment.allowed) && currentStepIndex < 2 && (0, jsx_runtime_1.jsx)(TapChoices_1.default, {}), (0, jsx_runtime_1.jsx)(StepContainer_1.default, { appointment: localAppointment, bookingFlowType: null })] }));
};
exports.BookNewAppointmentFlowBody = BookNewAppointmentFlowBody;
const BookNewAppointmentFlowFooter = () => (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
exports.BookNewAppointmentFlowFooter = BookNewAppointmentFlowFooter;
